export enum FunctionMode {
  VIEW = 'view',
  EDIT = 'edit',
  REVIEW = 'review',
}
